



















import { Vue, Component, Prop } from 'vue-property-decorator';
import type { IDocument } from '@signing-page/documents/types/document';
import DocumentHeader from '@signing-page/documents/components/DocumentHeader.vue';
import type { IEntity } from '@signing-page/entity/types/entity';
import ContentBlockContainer from '@signing-page/documents/components/ContentBlockContainer.vue';
import type { ITheme } from '@signing-page/api/theme/types/theme';

@Component({
  components: {
    DocumentHeader,
    ContentBlockContainer,
  },
})
export default class LobbyDocument extends Vue {
  @Prop() document: IDocument;
  @Prop() entity: IEntity;
  @Prop() theme: ITheme;

  get videoUrl(): string {
    return this.document.video && this.document.video.videoUrl;
  }

  get videoThumbnail(): string {
    return this.document.video && this.document.video.thumbUrl;
  }
}
